<header>
  <div  *ngIf="!isMobileLandscape && !isTabletLandscape" class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 text-center d-block d-lg-none">
        <p class="mb-4 header-font">Today is {{today | date:'fullDate'}}</p>
      </div>
      <div class="col-sm-12 col-lg-3">
            
        <img *ngIf="clientBrandObj.branding_product"  class="branding_sagility" src="..../../../../assets/{{clientBrandObj.branding_product}}" width="100%">
    </div>
    <div class="col-sm-12 col-lg-5">
        
      <img *ngIf="clientBrandObj.branding_client" class="branding_allianze" src=".../../../../assets/{{clientBrandObj.branding_client}}" width="100%">
    </div>
     <div class="col-sm-12 col-md-4 text-right">
        <div class="right-links">
          <ul>
            <!-- <li>
              <a href="javascript:;" class="fev" (click)="showFevToggle()">
                <i class="fa fa-heart-o" aria-hidden="true"></i>
              </a>
              <div *ngIf="showFev" class="drop-down-menu shadow-sm">
                <ul>
                  <li>
                    <a href="javascript:;">Settings</a>
                  </li>
                  <li>
                    <a (click)="logout()">Log out</a>
                  </li>
                </ul>
              </div>
            </li> -->
            <li class="d-none d-lg-block " >
              <p class="mb-0 today-date">
                Today is {{today | date:'EEEE'}},<br>
                {{today | date:'MMMM d, yyyy'}}
              </p>
              
            </li>
            <!-- <li (click)="showAlertBar()">
              <a href="javascript:;" class="bell">
                <i class="fa fa-bell-o" aria-hidden="true"></i>
                <span class="badges">8</span>
              </a>
            </li> -->
            <li>
              <a href="javascript:;" class="admin" title="Policy Holder">
                <select (focus)="showFullName()" (blur)="showFirstName()" (change)="changeStatus($event)" class="text-wrap">
                  <option [value]="usersDetails?.memberId" [selected] = "usersDetails?.memberId == currentMember">
                  {{firstNameOption}}
                  </option>
                  <option [value]="u.memberId" [selected] = "u?.memberId == currentMember" *ngFor="let u of usersDetails?.users" >
                    {{u.firstName}} {{u.lastName}}
                  </option>
                  <option value="Logout">Logout</option>
                </select>
              </a>
               <div *ngIf="showAdmin" class="drop-down-menu shadow-sm"
                (click)="$event.stopPropagation()">
                <ul>
                    <li>
                        <a (click)="logout()">Logout</a>
                        <!-- <a href="javascript:;" routerLink="/login">Log out</a> -->
                    </li>
                </ul>
              </div>            
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
   
    <div  *ngIf="isMobileLandscape" class="container-fluid"  style="height:auto">
      <div class="row align-items-center">
        <div class="col-12 text-center d-block d-lg-none">
          <p class="mb-4 header-font">Today is {{today | date:'fullDate'}}</p>
        </div>
        <div class="col-sm-12 col-lg-3" style="margin-top:-20px">
              
          <img *ngIf="clientBrandObj.branding_product"  class="branding_sagility" style="height:50px" src="..../../../../assets/{{clientBrandObj.branding_product}}" width="100%" alt="branding_sagility">
     
          
        <img *ngIf="clientBrandObj.branding_client" class="branding_allianze" src=".../../../../assets/{{clientBrandObj.branding_client}}" width="100%" alt="branding_allianze">
      </div>
       <div class="col-sm-12 col-md-4 float-md-right text-right">
          <div class="right-links" style="margin-top: -20px;
          margin-right: -20px;">
            <ul>
              
              <li class="d-none d-lg-block ">
                <p class="mb-0">Today is {{today | date:'fullDate'}}</p>
              </li>
              
              <li>
                <a href="javascript:;" class="admin"  title="Policy Holder">
                  <select (focus)="showFullName()" (blur)="showFirstName()" (change)="changeStatus($event)" class="text-wrap">
                    <option [value]="usersDetails?.memberId" [selected] = "usersDetails?.memberId == currentMember">
                    {{firstNameOption}}
                    </option>
                    <option [value]="u.memberId" [selected] = "u?.memberId == currentMember" *ngFor="let u of usersDetails?.users">
                      {{u.firstName}} {{u.lastName}}
                    </option>
                    <option>Logout</option>
                    </select>
                </a>
                <div *ngIf="showAdmin" class="drop-down-menu shadow-sm"
                  (click)="$event.stopPropagation()">
                  <ul>
                    <li>
                      <a (click)="logout()">Logout</a>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <!-- tab -->
    <div  *ngIf="isTabletLandscape" class="container-fluid"  style="height:auto">
      <div class="row align-items-center">
        <div class="col-12 text-center d-block d-lg-none">
          <p class="mb-4 header-font">Today is {{today | date:'fullDate'}}</p>
        </div>
        <div class="col-sm-12 col-lg-3" style="margin-top:-20px">
              
          <img *ngIf="clientBrandObj.branding_product"  class="branding_sagility" style="height:75px;" src="..../../../../assets/{{clientBrandObj.branding_product}}" width="100%" alt="branding_sagility">
     
          
        <img *ngIf="clientBrandObj.branding_client" class="branding_allianze"  style="height:75px" src=".../../../../assets/{{clientBrandObj.branding_client}}" width="100%" alt="branding_allianze">
      </div>
       <div class="col-sm-12 col-lg-5 text-right">
          <div class="right-links" style="margin-top: -20px;
          margin-right: -20px;">
            <ul>
              
              <li class="d-none d-lg-block ">
                <p class="mb-0">Today is {{today | date:'fullDate'}}</p>
              </li>
              
              <li>
                <a href="javascript:;" class="admin"  title="Policy Holder">
                  <select (focus)="showFullName()" (blur)="showFirstName()" (change)="changeStatus($event)" class="text-wrap">
                    <option [value]="usersDetails?.memberId" [selected] = "usersDetails?.memberId == currentMember">
                    {{firstNameOption}}
                    </option>
                    <option  [value]="u.memberId" [selected] = "u?.memberId == currentMember" *ngFor="let u of usersDetails?.users">
                      {{u.firstName}} {{u.lastName}}
                    </option>
                    <option>Logout</option>
                    </select>
                </a>
                <div *ngIf="showAdmin" class="drop-down-menu shadow-sm"
                  (click)="$event.stopPropagation()">
                  <ul>
                    <li>
                      <a (click)="logout()">Logout</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</header>

